// Site router endpoints (1:1), keyed by bare site_slug:
//   GET|PUT|DELETE /api/v1/sites/{site_slug}/router
// Mirrors backend/src/orixen_hub/api/v1/site_network.py.

import { request, type ApiResponse } from "../client";
import type { RouterConfig, RouterIn } from "../types/siteNetwork";

const routerPath = (s: string) => `/api/v1/sites/${encodeURIComponent(s)}/router`;

export const siteRouter = {
  get: (siteSlug: string): Promise<ApiResponse<RouterConfig>> =>
    request<RouterConfig>("GET", routerPath(siteSlug)),

  put: (siteSlug: string, body: RouterIn): Promise<ApiResponse<RouterConfig>> =>
    request<RouterConfig>("PUT", routerPath(siteSlug), body),

  remove: (siteSlug: string): Promise<ApiResponse<void>> =>
    request<void>("DELETE", routerPath(siteSlug)),
};
